import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/vip_jficon.png'


const _withScopeId = n => (_pushScopeId("data-v-3acaa2a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "leve" }
const _hoisted_3 = { class: "leve-cone" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "snuer" }
const _hoisted_6 = { class: "nuearm" }
const _hoisted_7 = { class: "nuearm-title" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "right"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "envelope"
}
const _hoisted_15 = { class: "envelope-title" }
const _hoisted_16 = { class: "evelopebox" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "right_no"
}
const _hoisted_20 = { class: "hint" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "taskItem" }
const _hoisted_23 = { class: "left" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "content" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "info" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_29 = ["onClick", "src"]
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "VIP",
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "leve-cone-bg",
          src: $setup.vipLevelBg[$setup.tmpLevel],
          alt: ""
        }, null, 8 /* PROPS */, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: $setup.vipLevelTitle[$setup.tmpLevel],
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_9),
                _createElementVNode("p", {
                  class: "nuearm-bntiel",
                  style: _normalizeStyle({ color: $setup.textColor[$setup.tmpLevel] })
                }, _toDisplayString($setup.VIPDESC[$setup.tmpLevel]), 5 /* TEXT, STYLE */)
              ]),
              ($setup.tmpLevel > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: $setup.vipLevelImg[$setup.tmpLevel - 1],
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_11)
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" <p :style=\"{ color: textColor[tmpLevel] }\">会员</p> ")
            ]),
            ($setup.tmpLevel != 5)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "nuearm-Circle",
                  style: _normalizeStyle({ backgroundColor: $setup.getCircleBg() })
                }, [
                  _createElementVNode("p", {
                    style: _normalizeStyle({ width: $setup.Circle + '%' })
                  }, null, 4 /* STYLE */)
                ], 4 /* STYLE */))
              : _createCommentVNode("v-if", true),
            ($setup.tmpLevel != 5)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "nuearm-bottom",
                  style: _normalizeStyle({ color: $setup.textColor[$setup.tmpLevel] })
                }, [
                  _createCommentVNode(" <span>{{ LEVEL[tmpLevel] }}</span> "),
                  ($setup.th == 'th')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "ยังมีมูลค่าการเติบโต " + _toDisplayString($setup.nextexp) + " ให้อัปเกรด", 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('tips.haicha')) + _toDisplayString($setup.nextexp) + _toDisplayString(_ctx.$t('tips.czzksj')), 1 /* TEXT */)),
                  _createElementVNode("span", null, _toDisplayString($setup.LEVEL[$setup.tmpLevel + 1]), 1 /* TEXT */)
                ], 4 /* STYLE */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      ($setup.tmpLevel > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('me.zxhb')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  class: "vipjf",
                  src: $setup.getJfBg(),
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_18),
                _createElementVNode("span", null, _toDisplayString($setup.getJfTitle()) + _toDisplayString(_ctx.$t('me.zxhbjf')), 1 /* TEXT */)
              ]),
              ($setup.is_send == 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "right",
                    onClick: $setup.onClickReward
                  }, _toDisplayString(_ctx.$t('me.lq')), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('me.ylq')), 1 /* TEXT */))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('me.mystatk')), 1 /* TEXT */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listData, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("img", {
                class: "icon",
                src: $setup.getTaskIcon(item.type),
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_24),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(item.title), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", null, _toDisplayString(item.score) + _toDisplayString(_ctx.$t('me.mystat2k')), 1 /* TEXT */)
                ])
              ])
            ]),
            (item.is_complete == 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "btn",
                  onClick: ($event: any) => ($setup.taskToRouter(item.type)),
                  src: $setup.taskbtn,
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_29))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "btn",
                  src: $setup.taskbtn1,
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_30))
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}